import React, { useEffect } from "react";
import {
  useRoutes,
  RouteObject,
  useLocation,
} from "react-router-dom";

interface RootRouteProps {
  allRoutes: RouteObject[];
}

const RootRoute: React.FC<RootRouteProps> = ({ allRoutes }) => {
  const routes = useRoutes([...allRoutes]);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return routes;
};

export default RootRoute;
